export default __webpack_public_path__ + "static/Survive-Japan-Knowing-Only-English-Info-Centres-ecde5fcb86b3f70cd0d07f9a8814823f.jpg";